import React from "react";
import styled from "styled-components";
import { primaryColor, tuftsBlue } from "../../../constants/colors";
import { useSelector } from "react-redux";
import { IoClose } from "react-icons/io5";
const AppointmentOrderSummary = ({ isApplyCouponVisible, coupon, discount, serviceAmount, subtotal, payableAmount, totalTaxAmount, taxes, onAppyCouponClick, onRemoveCoupon }) => {
  const { settings } = useSelector((state) => state.appSlice);
  return (
    <Wrapper>
      <div className="row px-4 py-1 mt-2">
        <div className="d-flex justify-content-between rounded gap-3"></div>
      </div>
      <div className="infoItemWrapper">
        <div className="info__item">
          <span>Consultation Charge</span>
          <strong>{`${settings.currency}${serviceAmount.toFixed(2)}`}</strong>
        </div>
        {coupon && (
          <div className="info__item coupon">
            <div className="d-flex flex-column">
              <span>Coupon Discount</span>
              <strong className="fs-normal">
                {coupon?.coupon?.toUpperCase()}
                <IoClose className="xIcon" color="#000" size={14} onClick={onRemoveCoupon} />
              </strong>
            </div>
            <div className="couponInfo">
              <strong>{`${settings.currency}${discount.toFixed(2)}`}</strong>
            </div>
          </div>
        )}

        <div className="info__item subtotal">
          <span>Sub Total</span>
          <strong className="text-white">{`${settings.currency}${subtotal.toFixed(2)}`}</strong>
        </div>
        {taxes?.length > 0 && (
          <>
            {taxes.map((taxItem, i) => (
              <div key={i} className="info__item">
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  {`${taxItem.tax_title}`}
                  {taxItem.type == 0 && <span style={{ fontWeight: " bold", color: tuftsBlue, fontSize: 12 }}>{`(${taxItem.value}%)`}</span>}
                </span>
                <strong>{`${settings.currency}${taxItem.tax_amount.toFixed(2)}`}</strong>
              </div>
            ))}
          </>
        )}
        <div className="info__item payable">
          <span>Payable Amount</span>
          <strong>{`${settings.currency}${payableAmount.toFixed(2)}`}</strong>
        </div>
        {isApplyCouponVisible && (
          <button type="button" className="info__item coupon" onClick={onAppyCouponClick}>
            <span></span>
            <strong className="coupon__title">
              <img src="/images/icons/ic_voucher.png" alt="Voucher Icon" />
              {`Apply Coupon`}
            </strong>
          </button>
        )}
      </div>
    </Wrapper>
  );
};

export default AppointmentOrderSummary;

const Wrapper = styled.div`
  button {
    outline: none;
    border: none;
  }
  .txt-gray {
    color: #b1b1b1;
  }
  .txt-primary {
    color: ${tuftsBlue};
  }
  .subtotal {
    background-color: ${tuftsBlue} !important;
    color: #fff !important;
  }
  .payable {
    background-color: #3b3b3b !important;
    span,
    strong {
      color: #fff !important;
    }
  }
  .infoItemWrapper {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    .info__item {
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.85rem 16px 0.85rem 16px;
      color: gray;
      strong {
        color: ${tuftsBlue};
        img {
          height: 20px;
          width: 20px;
          object-fit: contain;
          margin-right: 6px;
        }
      }
    }
    .coupon__title {
      font-size: 0.9rem;
    }
  }

  .xIcon {
    background-color: #d6d6d6;
    height: 22px;
    width: 22px;
    margin-left: 4px;
    border-radius: 30px;
  }
`;
